class BrandingTransformer {
  static fetch(branding) {
    return {
      primaryColor: branding.primaryColor,
    };
  }
}

export default BrandingTransformer;
